<template>
  <div class="vstudio20-presets-container">
    <f-form scroll>
      <template #title>
        <f-icon icon="fa6-sliders"></f-icon>{{ $vt('Scene presets') }}
        <div class="actions">
          
          <f-tooltip>
            <template #text>
              <div class="presets-help-tooltip">
                <strong>{{ $vt('Shortcut Keys') }} </strong>
                <ul>
                    <li><Key>Ctrl</Key><Key>Alt</Key><Key>1–0</Key> - {{ $vt('Presets 1–10') }}</li>
                  <li><Key>Ctrl</Key><Key>Alt</Key><Key>Shift</Key><Key>A–Z</Key> - {{ $vt('Presets 11–36') }}</li>
                </ul>
              </div>
            </template>
            <f-button :type="['transparent', 'icon', 'small']">
              <f-icon icon="fa6-question"></f-icon>
            </f-button>
          </f-tooltip>
          <f-tooltip>
            <template #text>
              <div class="presets-help-tooltip">
                <strong>{{ $vt('Save and restore') }} </strong>
                <ul>
                  <li>{{ $vt('Graphics visibility') }}</li>
                  <li>{{ $vt('Selected sources') }}</li>
                  <li>{{ $vt('Selected Layout') }}</li>
                  <li>{{ $vt('Audio configuration') }}</li>
                </ul>
              </div>
            </template>
            <f-button :type="['transparent', 'icon', 'small']">
              <f-icon icon="fa6-info"></f-icon>
            </f-button>
          </f-tooltip>

          <f-tooltip :text="$vt('Add a new preset')">
            <f-button :type="['filled', 'icon', 'small']" @click="addPresets()">
              <f-icon icon="fa6-plus"></f-icon>
            </f-button>
          </f-tooltip>

          <f-tooltip :text="$vt('Close preset panel')">
            <f-button
              :type="['transparent', 'icon', 'small']"
              @click="$emit('close')"
            >
              <f-icon icon="fa6-down-left-and-up-right-to-center"></f-icon>
            </f-button>
          </f-tooltip>
        </div>
      </template>
      <template #content>
        <div class="vstudio20-layers" v-if="hasPresets">
          <VStudio20PresetsPreset
            v-for="(preset, nid, index) in component.presets"
            :ref="nid"
            :preset="preset"
            :handler="handler"
            :short-key="keysList[index]"
            :key="nid"
            @delete="deletePreset(preset)"
            @rename="renamePreset(preset)"
            @set="setPreset(preset)"
            @apply="applyPreset(preset)"
          ></VStudio20PresetsPreset>
        </div>
        <div class="vstudio20-layers no-presets" v-else>
          <br>
          <f-button
            type="primary"
            class="vstudio20-button create-button"
            @click="addPresets()"
          >
            {{ $vt('Add') }}
          </f-button>
        </div>
      </template>
      <template #action> </template>
    </f-form>
  </div>
</template>
<script>
import ngContextMixin from "/vodalys/vvuejs/mixins/ngContext.mjs";

import VStudio20PresetsPreset from "./VStudio20PresetsPreset.vue";
import Key from "./Key.vue";


const keysList = [
  { modifiers: ['Ctrl', 'Alt'], key: '1' },
  { modifiers: ['Ctrl', 'Alt'], key: '2' },
  { modifiers: ['Ctrl', 'Alt'], key: '3' },
  { modifiers: ['Ctrl', 'Alt'], key: '4' },
  { modifiers: ['Ctrl', 'Alt'], key: '5' },
  { modifiers: ['Ctrl', 'Alt'], key: '6' },
  { modifiers: ['Ctrl', 'Alt'], key: '7' },
  { modifiers: ['Ctrl', 'Alt'], key: '8' },
  { modifiers: ['Ctrl', 'Alt'], key: '9' },
  { modifiers: ['Ctrl', 'Alt'], key: '0' },
  { modifiers: ['Ctrl', 'Alt', 'Shift'], key: 'A' },
  { modifiers: ['Ctrl', 'Alt', 'Shift'], key: 'B' },
  { modifiers: ['Ctrl', 'Alt', 'Shift'], key: 'C' },
  { modifiers: ['Ctrl', 'Alt', 'Shift'], key: 'D' },
  { modifiers: ['Ctrl', 'Alt', 'Shift'], key: 'E' },
  { modifiers: ['Ctrl', 'Alt', 'Shift'], key: 'F' },
  { modifiers: ['Ctrl', 'Alt', 'Shift'], key: 'G' },
  { modifiers: ['Ctrl', 'Alt', 'Shift'], key: 'H' },
  { modifiers: ['Ctrl', 'Alt', 'Shift'], key: 'I' },
  { modifiers: ['Ctrl', 'Alt', 'Shift'], key: 'J' },
  { modifiers: ['Ctrl', 'Alt', 'Shift'], key: 'K' },
  { modifiers: ['Ctrl', 'Alt', 'Shift'], key: 'L' },
  { modifiers: ['Ctrl', 'Alt', 'Shift'], key: 'M' },
  { modifiers: ['Ctrl', 'Alt', 'Shift'], key: 'N' },
  { modifiers: ['Ctrl', 'Alt', 'Shift'], key: 'O' },
  { modifiers: ['Ctrl', 'Alt', 'Shift'], key: 'P' },
  { modifiers: ['Ctrl', 'Alt', 'Shift'], key: 'Q' },
  { modifiers: ['Ctrl', 'Alt', 'Shift'], key: 'R' },
  { modifiers: ['Ctrl', 'Alt', 'Shift'], key: 'S' },
  { modifiers: ['Ctrl', 'Alt', 'Shift'], key: 'T' },
  { modifiers: ['Ctrl', 'Alt', 'Shift'], key: 'U' },
  { modifiers: ['Ctrl', 'Alt', 'Shift'], key: 'V' },
  { modifiers: ['Ctrl', 'Alt', 'Shift'], key: 'W' },
  { modifiers: ['Ctrl', 'Alt', 'Shift'], key: 'X' },
  { modifiers: ['Ctrl', 'Alt', 'Shift'], key: 'Y' },
  { modifiers: ['Ctrl', 'Alt', 'Shift'], key: 'Z' }
]

export default {
  translate25Context: 'vstudio20_presets',
  mixins: [ngContextMixin], // on ajoute le mixin ngCOntext qui ajoute un helper this.ngContext() qui chope le context angular (^scope, $element, $injector)
  components: {
    VStudio20PresetsPreset,
    Key
  },
  methods: {
    addPresets() {
      this.handler.action(this.component["#id"], "add_preset", []);
    },
    deletePreset(preset) {
      this.ngContext(({ $scope, $element, $injector }) => {
        const v17Modal = $injector.get("v17Modal");

        v17Modal.yesNo($scope, $element, {
          title: this.$vt("Remove preset"),
          message: `${this.$vt('Remove preset \"')}${preset.title}"`,
          yesLabel: this.$vt("Remove"),
          yesType: 'negative',
          noLabel: this.$vt("Cancel"),
          yes: () => {
            return this.handler
              .action(preset["#id"], "delete_preset")
              .then((_) => {
                // console.log("preset deleted", _);
              });
          },
        });
      });
    },
    setPreset(preset) {
      this.ngContext(({ $scope, $element, $injector }) => {
        const v17Modal = $injector.get("v17Modal");
        v17Modal.yesNo($scope, $element, {
          title: this.$vt("Save configuration"),
          message: `${this.$vt('Save current configuration in preset \"')}${preset.title}"`,
          yes: () => {
            return this.handler
              .action(preset["#id"], "save_preset")
              .then((_) => {
                // console.log("preset saved", _);
              });
          },
        });
      });
    },
    applyPreset(preset) {
      this.handler.action(preset["#id"], "apply_preset").then((_) => {
        // console.log("preset applied", _);
      });
    },
    renamePreset(preset) {
      this.ngContext(({ $scope, $element, $injector }) => {
        const v17Modal = $injector.get("v17Modal");

        v17Modal.input($scope, $element, {
          title: this.$vt("Rename preset"),
          placeholder: preset.title,
          ok: (title) => {
            return this.handler
              .action(preset["#id"], "rename_preset", [title])
              .then((_) => {
                // console.log("preset renamed", _);
              });
          },
        });
      });
    },
  },
  computed: {
    hasPresets() {
      return (
        this.component.presets &&
        Object.entries(this.component.presets).length > 0
      );
    },
  },
  data() {
    return {
      keysList,
    };
  },
  mounted() {
    this._keyListener = function (e) {
      var keys = {
        "&": "1",
        é: "2",
        "#": "3",
        "{": "4",
        "[": "5",
        "|": "6",
        è: "7",
        "\\": "8",
        "^": "9",
        "@": "0",

        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        0: "0",

        // Alphabetical order (A-Z)
        a: "a",
        b: "b",
        c: "c",
        d: "d",
        e: "e",
        f: "f",
        g: "g",
        h: "h",
        i: "i",
        j: "j",
        k: "k",
        l: "l",
        m: "m",
        n: "n",
        o: "o",
        p: "p",
        q: "q",
        r: "r",
        s: "s",
        t: "t",
        u: "u",
        v: "v",
        w: "w",
        x: "x",
        y: "y",
        z: "z",
      };

      var key = keys[e.key];
      var preset_nids = Object.keys(this.component.presets);
      var index;

      // For numeric keys (1-0) and AZERTY keys (&é"'(-è_çà), use Ctrl+Alt
      if (
        Object.keys(keys).indexOf(e.key) != -1 &&
        e.ctrlKey &&
        e.altKey &&
        !e.shiftKey &&
        (/^[0-9]$/.test(key) || ["&", "é", "\"", "'", "(", "-", "è", "_", "ç", "à"].includes(e.key))
      ) {
        index = parseInt(key === "0" ? "10" : key) - 1;
      } 
      // For alphabetic keys (a-z), use Ctrl+Alt+Shift
      else if (
        e.ctrlKey &&
        e.altKey &&
        e.shiftKey &&
        /^[A-Za-z]$/.test(e.key)
      ) {
        var lowerKey = e.key.toLowerCase();
        index = lowerKey.charCodeAt(0) - 'a'.charCodeAt(0) + 10; // a=10, b=11, ..., z=35
      }

      if (index !== undefined && index < preset_nids.length) {
        e.preventDefault();

        var preset_nid = preset_nids[index];

        this.$refs[preset_nid][0].apply();
      }
    };

    this.__keyListener = this._keyListener.bind(this);

    document.addEventListener("keydown", this.__keyListener);
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.__keyListener);
  },
  props: ["component", "handler"],
};
</script>


<style lang="scss">
.presets-help-tooltip {
  text-align: left;
  font-weight: initial;

  .quote {
    font-size: 0.9em;
    padding-left: 10px;
    display: block;
    border-left: 1px solid lightgray;
  }
}
.vstudio20-presets-container form > .content-container {
  flex: 1 1 auto;

  .content {
    padding: 0;

    .vstudio20-layers .vfigma-list-item.default:hover,
    .vstudio20-layers .vfigma-list-item.default:active,
    .vstudio20-layers .vfigma-list-item.default:active:hover{
      background-color: transparent;
      color: #161615bf;
    }
  }
}
</style>

<style lang="scss" scoped>
.vstudio20-presets-container {
  display: flex;
  flex-direction: row;
  height: 100%;
  width: 360px;

  .f-form {
    width: 100%;

    .title {
      .actions {
        display: flex;
        gap: 7px;
        margin-left: auto;
      }
    }

    .vstudio20-layers.no-presets {
      align-self: center;
      justify-self: center;
      margin: auto;
      display: flex;
      flex-direction: column;

      .f-button {
        margin-top: 10px;
      }
    }
  }
}

.vstudio20-presets {
  position: relative;
  flex: 0 0 auto;
  height: 100%;

  top: 0;
  bottom: 0;

  width: 350px;

  margin-left: 10px;

  // .fa-info {
  //   // font-size: .9em;
  //   // margin-left: 1em;
  //   // border-bottom: 1px dotted grey;

  //   cursor: help;
  // }

  .vstudio20-layers {
    width: 100%;
    overflow-y: auto;
    display: flex;
    flex-direction: column;

    flex: 1 0 0;

    &.no-presets {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: relative;
      padding: 10px;

      .create-button {
        margin-top: 10px;
        background-color: #5cbab6;
        color: white;
      }
    }
  }

  .head {
    border-bottom: solid 5px #f2f2f2;
  }

  .settings {
    margin-left: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    cursor: pointer;

    .vstudio20-button {
      margin-left: 10px;

      &.help {
        cursor: help;
      }

      &.main {
        background-color: #5cbab6;
        color: white;
      }
    }
  }
}
</style>